import { PatientDataCompareKey } from '../../../Helpers/Patient/mapPatientDataToCompareTable.helper';
import { NCZIPatientJRUZ } from '../Interfaces/ncziPatientInformations';

export const PATIENT_AUTO_VERIFY_COMPARED_KEYS: PatientDataCompareKey[] = [
	'firstName',
	'lastName',
	'address.street',
	'address.descriptiveNumber',
	'address.guideNumber',
	'address.city',
	'address.postCode',
	'insuranceCompanyCode',
];

const normalize = (value?: string): string =>
	(value ?? '').toString().trim().replace(/\s+/g, ' ').toLowerCase();

const normalizeCompact = (value?: string): string =>
	(value ?? '').toString().replace(/\s+/g, '').toLowerCase();

const isEqualValue = (key: PatientDataCompareKey, a?: string, b?: string) =>
	key === 'address.postCode' || key === 'insuranceCompanyCode'
		? normalizeCompact(a) === normalizeCompact(b)
		: normalize(a) === normalize(b);

export const findPatientDataMismatchKeys = (
	ncziData: Record<PatientDataCompareKey, string>,
	patientData: Record<PatientDataCompareKey, string>,
): PatientDataCompareKey[] =>
	PATIENT_AUTO_VERIFY_COMPARED_KEYS.filter(key => {
		const ncziValue = ncziData[key];
		if (!normalize(ncziValue)) {
			return false;
		}

		return !isEqualValue(key, ncziValue, patientData[key]);
	});

export interface InsuranceCompanyTermItem {
	name?: string;
	value?: string;
	value2?: string;
	value3?: string;
}

export const resolveNcziInsuranceKey = (
	jruz: NCZIPatientJRUZ | undefined,
	termItems: InsuranceCompanyTermItem[],
): string | undefined => {
	const company = jruz?.insurance?.company;
	if (!company) {
		return undefined;
	}

	const code = normalizeCompact(company.code?.value);
	const displayName = normalize(company.displayName);

	const matched = termItems.find(item => {
		if (code && normalizeCompact(item.value) === code) {
			return true;
		}
		if (code && normalizeCompact(item.value2) === code) {
			return true;
		}
		return !!displayName && normalize(item.name) === displayName;
	});

	return matched?.value3 ?? undefined;
};
